import { debounce } from "lodash";
import { useCallback, useMemo, useState } from "react";
import { ManagementCompany } from "src/pages/Admin/ManagmentCompanies/types";
import { getManagementCompaniesRequest } from "src/services/admin/queries/managementCompanies";

const debouncedOnSearchMs = 400;

type State = {
	data?: ManagementCompany[];
	error: boolean;
	loading: boolean;
	term: string;
	filter?: string;
};

const initialState: State = {
	error: false,
	loading: false,
	term: "",
	filter: "ALL"
};

export default function useGetManageCompaniesSearch() {
	const [state, setState] = useState<State>(initialState);

	async function query(term: string, filter?: string) {
		if (!term) return setState({ ...initialState, term });

		function fetch() {
			try {
				setState({ ...state, loading: true, error: false, term, filter });
				getManagementCompaniesRequest(term, false, 0, 50)
					.then((data) =>
						setState({ loading: false, error: false, data: data.items, term, filter })
					)
					.catch(() => setState({ loading: false, error: true, term, filter }));
			} catch (e) {
				setState({ loading: false, error: true, term, filter });
				console.error("error", e);
			}
		}

		fetch();
	}

	const onSearch = useCallback((term: string, filter?: string) => {
		query(term, filter);
	}, []);

	const debouncedOnSearch = useMemo(
		() =>
			debounce((term: string, filter?: string) => onSearch?.(term, filter), debouncedOnSearchMs),
		[onSearch]
	);

	function onInputChange(_: any, term: string) {
		debouncedOnSearch(term);
	}

	function onFilterChange(filter: string) {
		debouncedOnSearch(state.term, filter);
	}

	return {
		...state,
		onInputChange,
		onFilterChange
	};
}
